// 2_components/cart_widget.js
// Cart widget: mirrors the header cart total price into the #cart-widget
// button on cart updates, and on mobile/tablet redirects the header cart
// button straight to the cart page.

let priceAddedToCartWidget = false;

export function init() {
	if (!window.NAT?.utils?.addSmartTouchClickListener) {
		console.warn("[NAT] cart_widget.js: window.NAT.utils.addSmartTouchClickListener missing — check load order");
		return;
	}

	/*------------------------------------------------- CART WIDGET - total price into the widget*/
	document.addEventListener("ShoptetDOMCartContentLoaded", function () {
		insertTotalPriceToCartWidget();
	});

	/*-------------------------------------- CART WIDGET - on mobile go straight to the cart*/
	addCartWidgetToCartMobileListener();
}

function insertTotalPriceToCartWidget() {
	const header = document.getElementById("header");
	if (!header.querySelector(".cart-price")) {
		return;
	}
	const totalPrice = header.querySelector(".cart-price").textContent.trim();
	if (!totalPrice) {
		return;
	}

	const cartWidgetButton = document.querySelector("#cart-widget .cart-widget-button");
	if (!cartWidgetButton) {
		return;
	}

	if (priceAddedToCartWidget) {
		const existingTotalPriceElement = cartWidgetButton.querySelector(".cart-total-price-wrapper");
		if (existingTotalPriceElement) {
			const totalPriceStrong = existingTotalPriceElement.querySelector(".cart-total-price");
			if (totalPriceStrong) {
				totalPriceStrong.innerHTML = totalPrice;
			}
		}
		return;
	}

	const totalPriceInCartWidgetElement = document.createElement("div");
	totalPriceInCartWidgetElement.className = "cart-total-price-wrapper";

	const totalPriceStrong = document.createElement("strong");
	totalPriceStrong.className = "cart-total-price";
	totalPriceStrong.innerHTML = totalPrice;

	const totalPriceLabel = document.createElement("span");

	totalPriceLabel.innerHTML = window.NAT.translations("cartTotalLabel");

	totalPriceInCartWidgetElement.appendChild(totalPriceLabel);
	totalPriceInCartWidgetElement.appendChild(totalPriceStrong);
	cartWidgetButton.appendChild(totalPriceInCartWidgetElement);
	priceAddedToCartWidget = true;
}

function addCartWidgetToCartMobileListener() {
	const header = document.getElementById("header");
	const cartButton = header.querySelector(".navigation-buttons");
	if (!cartButton) {
		console.warn("Cart button not found.");
		return;
	}
	const cartHrefA = cartButton.querySelector("a");
	if (!cartHrefA) {
		console.warn("Cart button href not found.");
		return;
	}
	const cartHref = cartHrefA.getAttribute("href");
	if (!cartHref) {
		console.warn("Cart button href is empty.");
		return;
	}

	window.NAT.utils.addSmartTouchClickListener(cartButton, function (event) {
		if (!window.NAT.media.isDesktop) {
			console.log("Cart button clicked on mobile, redirecting to cart page.");
			event.preventDefault();
			window.location.href = cartHref;
		} else {
			console.log("Cart button clicked on desktop, no action needed.");
		}
	});
}
